/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SummaryTableSubTittleDto } from './SummaryTableSubTittleDto';
import {
    SummaryTableSubTittleDtoFromJSON,
    SummaryTableSubTittleDtoFromJSONTyped,
    SummaryTableSubTittleDtoToJSON,
} from './SummaryTableSubTittleDto';

/**
 * 
 * @export
 * @interface SummaryTableTittleDto
 */
export interface SummaryTableTittleDto {
    /**
     * 
     * @type {string}
     * @memberof SummaryTableTittleDto
     */
    titleName: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryTableTittleDto
     */
    reference: string;
    /**
     * 
     * @type {Array<SummaryTableSubTittleDto>}
     * @memberof SummaryTableTittleDto
     */
    subTittles?: Array<SummaryTableSubTittleDto>;
}

/**
 * Check if a given object implements the SummaryTableTittleDto interface.
 */
export function instanceOfSummaryTableTittleDto(value: object): value is SummaryTableTittleDto {
    if (!('titleName' in value) || value['titleName'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    return true;
}

export function SummaryTableTittleDtoFromJSON(json: any): SummaryTableTittleDto {
    return SummaryTableTittleDtoFromJSONTyped(json, false);
}

export function SummaryTableTittleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryTableTittleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'titleName': json['titleName'],
        'reference': json['reference'],
        'subTittles': json['subTittles'] == null ? undefined : ((json['subTittles'] as Array<any>).map(SummaryTableSubTittleDtoFromJSON)),
    };
}

export function SummaryTableTittleDtoToJSON(value?: SummaryTableTittleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'titleName': value['titleName'],
        'reference': value['reference'],
        'subTittles': value['subTittles'] == null ? undefined : ((value['subTittles'] as Array<any>).map(SummaryTableSubTittleDtoToJSON)),
    };
}

